import { render } from "./BadgeComponent.vue?vue&type=template&id=748577d4&scoped=true"
import script from "./BadgeComponent.vue?vue&type=script&lang=js"
export * from "./BadgeComponent.vue?vue&type=script&lang=js"

import "./BadgeComponent.vue?vue&type=style&index=0&id=748577d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748577d4"]])

export default __exports__